import React from 'react';
import { useSelector } from 'react-redux';

import LabelsToolContent from '../LabelsToolContent';
import { LabelsToolbarPopupProps } from '../labelComponentPropTypes';
import { selectUsableLabels } from '../../../../../../element/labels/labelSelectors';

const LabelsToolbarPopupContent: React.FC<LabelsToolbarPopupProps> = (props) => {
    const labels = useSelector(selectUsableLabels);
    const allLabels = Object.values(labels || {});

    return <LabelsToolContent {...props} allLabels={allLabels} />;
};

export default LabelsToolbarPopupContent;
